export default {
    /**
     * These should all be model defaults that can be set to the
     * model from the url
     */
    hashModelSettings: {
        samplingRate: 0, // from adc
        vref: 0, // from adc
        gain: 1,
        rf: 50,
        cf: 0,
        frequency: 2000,
        multiplexed: false,
        wbNoise: 0.000000004,
        thd: 130,
        showOptionalSourceSettings: false,
        rext: 0, // from adc
        cext: 0, // from adc
        vcm: 2.5, // from adc
        // sinadChart: true,
        inputSettlingChart: 1,
        showAdcVariant: false,
        showDriverVariant: false,
        showHiZVariant: false,
        showSeqVariant: false,
        debugMode: false,
        vSupplyPos: 0, // calculated
        vSupplyNeg: 0, // calculated
    },

    otherModelSettings: {
        // Set min and max values
        minSamplingRate: 100000,
        minSimulationTimeSteps: 100,
        maxInputPulseRiseTime: 0.001,
        //minInputPulseRiseTime: 0.000000001,
        minInputPulseRiseTime: 0,
        //minLsb: ??,
        minLsb: 1,
        minVout: 0.1, //??
        maxGain: 10,
        maxWarningGain: 5,
        minGain: 0.2,
        //maxRf: ??,
        //minRf: ??,
        minFrequency: 1,
        maxRext: 2000,
        minRext: 2,
        maxCext: 0.0000001,
        minCext: 1e-11,
        maxWbNoise: 0.000001,
        minWbNoise: 0,
        maxThd: 200, //??
        minThd: 50,
        // Set defaults
        kt: (298 * (1.38e-23)),
        indexAtFreq: 0,
        // pulseTabError: false,
        averaging: 1
    },

    additionalHashModelSettings: {
        showOptionalSourceSettings: {
            wbNoise: 0,
            thd: 200
        }
    },

    modelToHashMap: {
        showOptionalSourceSettings: "oss",
        debugMode: "debug"
    }
}